/* Evalinne – mobile sticky add-to-cart: label, discount badge, chosen variant, size guard */
(function(){
  function ready(f){document.readyState!=='loading'?f():document.addEventListener('DOMContentLoaded',f);}
  ready(function(){
    var bar=document.getElementById('ev-sticky-bar'),btn=document.getElementById('ev-sticky-atc'),p=document.getElementById('ev-sticky-price');
    if(!bar||!btn)return;
    btn.innerHTML=btn.innerHTML.replace('Ajouter au panier','<span class="evs-l">Ajouter</span>');
    /* discount badge */
    function off(){if(!p)return;var o=p.querySelector('.evs-off');if(o)o.remove();var s=p.querySelector('s');if(!s)return;
      var n=function(t){return parseFloat((t||'').replace(/[^0-9,\.]/g,'').replace(',','.'))};
      var was=n(s.textContent),now=n(p.textContent.replace(s.textContent,''));
      if(was>now&&now>0){var e=document.createElement('span');e.className='evs-off';e.textContent='-'+Math.round((1-now/was)*100)+'%';p.appendChild(e);}}
    off();if(p&&window.MutationObserver){new MutationObserver(function(){if(!p.querySelector('.evs-off'))off();}).observe(p,{childList:true});}
    /* chosen variant line */
    var swatches=[].slice.call(document.querySelectorAll('.swatch_options .swatch[data-option-index]'));
    if(!swatches.length)return;
    var info=bar.querySelector('.ev-sticky-info'),line=document.createElement('div');line.className='evs-var';
    var title=info.querySelector('.ev-sticky-title');info.insertBefore(line,title?title.nextSibling:info.firstChild);
    var sizeSw=swatches.filter(function(s){var h=s.querySelector('.header');return h&&/pointure|taille|size/i.test(h.textContent);})[0];
    var sizeChosen=!sizeSw;
    function val(s){var c=s.querySelector('input:checked');return c?c.value:'';}
    function render(){
      var parts=[];
      swatches.forEach(function(s){if(s===sizeSw)return;var v=val(s);if(v)parts.push(v);});
      var html=parts.map(function(t){return '<span>'+t.replace(/</g,'&lt;')+'</span>';}).join('<i>·</i>');
      if(sizeSw){html+=(html?'<i>·</i>':'')+(sizeChosen?'<span>Pointure '+val(sizeSw)+'</span>':'<b>Pointure ?</b>');}
      line.innerHTML=html;bar.classList.add('evs-has-var');
    }
    render();
    swatches.forEach(function(s){s.addEventListener('change',function(){if(s===sizeSw)sizeChosen=true;setTimeout(render,0);});});
    document.querySelectorAll('.single-option-selector').forEach(function(sel){sel.addEventListener('change',function(){setTimeout(render,0);});});
    /* size guard: no size chosen yet -> scroll to sizes instead of adding the default one */
    document.addEventListener('click',function(e){
      if(sizeChosen||window.innerWidth>749||!e.target.closest||!e.target.closest('#ev-sticky-atc'))return;
      e.preventDefault();e.stopPropagation();
      var y=sizeSw.getBoundingClientRect().top+window.pageYOffset-140;
      window.scrollTo({top:y,behavior:'smooth'});
      sizeSw.classList.remove('evs-pulse');void sizeSw.offsetWidth;sizeSw.classList.add('evs-pulse');
      setTimeout(function(){sizeSw.classList.remove('evs-pulse');},2600);
    },true);
  });
})();
